import type { GridFilterItem } from '@mui/x-data-grid-pro';

export interface NegatedGridFilterItem extends GridFilterItem {
  negated?: boolean;
}

export function isNegated(item: GridFilterItem): boolean {
  return (item as NegatedGridFilterItem).negated === true;
}
